import React, { useContext, useEffect, useRef, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// Force TS recompile
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import AppSiderProblemesId from "./menus/AppSiderProblemesId";
import PracticaIdEnunciat from "./content/PracticaIdEnunciat";
import PracticaIdTests from "./content/PracticaIdTests";
import PracticaIdAlumnes from "./content/PracticaIdAlumnes";
import { FloatButton } from "antd";
import { GetPractica } from "../../../dao/jutge/GetPracticaId";
import { motion } from "framer-motion";
import PracticaIdEntrega from "./content/PracticaIdEntrega";
import ProblemaIdExemples from "../problemesId/content/ProblemaIdExemples";
import PracticaIdExemples from "./content/PracticaIdExemples";
import { GetJutgePracticaIdDocuments } from "../../../dao/jutge/GetJutgePracticaIdDocuments";
import { GetAlumneId } from "../../../dao/GetAlumneId";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";

const PracticaId = () => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne, setAlumneInfo } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id_practica } = useParams();
    const [dades, setDades] = (useState<any>())
    const [tests, setTests] = (useState<any>())
    const [documents, setDocuments] = useState<any[]>([]);
    const [pantalla, setPantalla] = useState(0);
    const [selectedRecord, setSelectedRecord] = useState<any>();
    const [activitat, setActivitat] = (useState<any>({ isExamen: true }))
    const interval = useRef<NodeJS.Timeout | null>(null);

    const [enviado, setEnviado] = useState(false);
    const [questionModal, setQuestionModal] = useState(false);
    const [tableModal, setTableModal] = useState(false);
    const [conversaModal, setConversaModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const MotionFloatButton = motion(FloatButton);

    UseWebSocketSubscription(["/topic/home"], () => {
        checkDades(false);
    });

    useEffect(() => {
        if (isLoggedIn) {
            checkDades(true);
        }
    }, [id_practica]);

    async function checkDades(refresh: boolean) {
        setEnviado(true);
        if (refresh) setLoading(true);

        const data = await GetPractica(id_practica + "");
        setDades(data);
        setTests(data.test);

        // ✅ Obtener documentos desde el endpoint específico para asegurar consistencia
        const docsData = await GetJutgePracticaIdDocuments(id_practica + "");
        setDocuments(docsData || []);

        const isExam = Number(data?.isExamen ?? data?.isExam ?? data?.is_examen) === 1;

        // Check Modo Examen del aula para alumnos:
        if (user.tipus !== "0" && user.tipus !== "1" && data) {
            let userAulas = alumne?.aules || [];
            if (userId) {
                try {
                    const al = await GetAlumneId(userId);
                    if (al?.aules) {
                        userAulas = al.aules;
                        if (setAlumneInfo) setAlumneInfo(al);
                    }
                } catch (e) {
                    // fallback
                }
            }
            const currentAula = (userAulas || []).find((a: any) => String(a.id || a.id_aula) === String(data.id_aula));
            const isAulaExamMode = currentAula && Boolean(currentAula.isExamen === 1 || currentAula.isExamen === true || currentAula.is_examen === 1 || currentAula.is_examen === true);

            // Si el aula está en modo examen, solo se permite acceder a exámenes activos (estat 3). Prácticas o exámenes cerrados redirigen a /jutge/examens
            if (isAulaExamMode) {
                if (!isExam || data.estat !== 3) {
                    navigate('/jutge/examens');
                    return;
                }
            }
        }

        //Si la práctica no está en estado 3, redirigimos
        if ((!data || (data.estat === 1)) && (user.tipus !== "0" && user.tipus !== "1")) {
            navigate(isExam ? '/jutge/examens' : '/jutge/practiques');
            return;
        }

        // ✅ Si hay documentos, selecciona el primero por defecto (Solo los asociados: visible === 1)
        const availableDocs = (docsData || []).filter((d: any) => d.visible === 1);
        if (availableDocs.length > 0) {
            setSelectedRecord(availableDocs[0]);
        }

        // ✅ Solo establecer la pantalla inicial si aún no se ha interactuado
        setPantalla((prev) => (prev !== undefined && prev !== null ? prev : 0));

        setBreadCrumb(
            [
                { nom: 'Home', nav: '/home' },
                { nom: 'jutge', nav: '/jutge' },
                ...(isExam 
                    ? [{ nom: 'exàmens', nav: '/jutge/examens' }] 
                    : [{ nom: 'practiques', nav: '/jutge/practiques' }]
                ),
                { nom: `${data?.nom}`, nav: `/jutge/practiques/${id_practica}` }
            ],
            true
        );

        setLoading(false);
        setEnviado(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSiderProblemesId
                    enunciats={documents}
                    setPantalla={setPnt}
                    pantalla={pantalla}
                    refresh={() => checkDades(true)}
                    practicaNom={dades?.nom}
                />
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    {pantalla === 0 && (
                        <PracticaIdEnunciat 
                            doc={selectedRecord} 
                            documents={documents}
                            loading={loading}
                            onSelectDoc={(doc) => setSelectedRecord(doc)}
                            practicaNom={dades?.nom}
                            onRefresh={() => checkDades(true)}
                        />
                    )}
                    {pantalla === 1 && <PracticaIdEntrega />}
                    {pantalla === 2 && <PracticaIdAlumnes />}
                </Content>
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};
export default PracticaId;
